import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { Color } from './color.model';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ColorService {
    private uri = `${environment.apiLocation}/Colors`;
    constructor(private http: HttpClient, private log: LoggingService) {}

    public get(): Observable<Array<Color>> {
        this.log.verbose({ type: 'ColorService:get' });
        return this.http.get<Array<Color>>(this.uri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'ColorService:get:response',
                    res
                })
            )
        );
    }
}
